import { Permission } from 'shared'
import { FieldDesignChange } from '../../../../FDCTrackerContext/types'
import { usePayItemSelectContext } from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { toMoment } from 'utils/toMoment'
import { useFDCTrackerContext } from '../../../../FDCTrackerContext'
import { toDisciplineValues } from '../../components/DisciplinesFormItem/utils/toDisciplineValues'
import EditModalBody from './components/EditModalBody'
import { EditModalBodyItems } from './components/EditModalBody/types'
import { toConcurrenceLevelValue } from '../../components/ConcurrenceLevelFormItem/utils/toConcurrenceLevelValue'

export function useEditOptions(): EditRowActionOptions<
  FieldDesignChange,
  EditModalBodyItems
> {
  const {
    mutations: { edit },
    fieldDesignChanges,
  } = useFDCTrackerContext()
  const { toMutateCustomFieldsInput, toCustomFieldEditorValue } =
    useProjectCustomFieldsContext()
  const { toLabeledValues: toPayItems, fromLabeledValues } =
    usePayItemSelectContext()
  return {
    permission: [
      Permission.EditFieldDesignChange,
      Permission.EditFieldDesignChangeResolution,
    ],
    modal: {
      body: (record) => <EditModalBody {...record} />,
      initialValues: ({
        externalLinks,
        issue,
        drawingsAffected,
        location,
        requestedApprovalDate,
        specsAffected,
        resolution,
        disciplines,
        fdcToPayItemNoGeometries,
        customFields,
        concurrenceLevel,
      }) => ({
        issue,
        drawingsAffected,
        location,
        requestedApprovalDate: toMoment(requestedApprovalDate),
        specsAffected,
        resolution,
        externalLinks: externalLinks.map(({ __typename, ...link }) => link),
        disciplines: toDisciplineValues(disciplines),
        payItems: toPayItems(
          fdcToPayItemNoGeometries.map(({ payItem }) => payItem)
        ),
        customFields: toCustomFieldEditorValue(customFields),
        concurrenceLevel: toConcurrenceLevelValue(concurrenceLevel),
      }),
      onOk: async (
        { id },
        {
          issue,
          disciplines,
          drawingsAffected,
          externalLinks,
          payItems,
          location,
          requestedApprovalDate,
          specsAffected,
          resolution,
          customFields,
          concurrenceLevel,
        }
      ) => {
        await edit.fn({
          variables: {
            input: {
              id,
              issue,
              disciplineIds: disciplines?.map(({ value }) => value as string),
              drawingsAffected,
              externalLinks,
              payItemIds: fromLabeledValues(payItems),
              location,
              specsAffected,
              requestedApprovalDate:
                requestedApprovalDate?.toISOString() ?? null,
              resolution,
              customFields: toMutateCustomFieldsInput(customFields),
              concurrenceLevelId: concurrenceLevel?.value as string,
            },
          },
        })
        fieldDesignChanges?.refetch()
      },
      recordName: 'formattedNumber',
    },
  }
}
